(function(){
  if(window.__toolioInit) return; window.__toolioInit = true;

  document.documentElement.classList.add('tl-js');

  var io;
  function initReveal(){
    var els = document.querySelectorAll('.tl-reveal:not(.tl-in)');
    if(!('IntersectionObserver' in window)){ els.forEach(function(el){ el.classList.add('tl-in'); }); return; }
    if(!io){
      io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ e.target.classList.add('tl-in'); io.unobserve(e.target); }
        });
      },{threshold:.12, rootMargin:'0px 0px -40px 0px'});
    }
    els.forEach(function(el){ io.observe(el); });
  }

  function revealAll(){
    document.querySelectorAll('.tl-reveal:not(.tl-in)').forEach(function(el){ el.classList.add('tl-in'); });
  }

  if(document.readyState !== 'loading'){ initReveal(); } else { document.addEventListener('DOMContentLoaded', initReveal); }
  document.addEventListener('shopify:section:load', initReveal);
  document.addEventListener('page:loaded', initReveal);
  window.addEventListener('load', function(){ setTimeout(revealAll, 1500); });
  setTimeout(revealAll, 2500);
  window.__toolioReveal = initReveal;
})();
